import React from 'react';
import swal from 'sweetalert';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import FilterSection from '../../../common/Filter';
import { WarningBox } from '../../../common/WarningBox';
import { ConfirmModal } from '../../../common/ConfirmModal';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { getLoggedUser } from '../../../../state/user';
import { ClientAmountCard } from '../../../common/ClientAmountCard';
import HeaderBanner from '../../../common/HeaderBanner';
import { getBidders, getClients } from '../CashFlowDashboard/services/cashFlowService';
import Select from 'react-select';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import { formatDate, getAvatarColor, getInitials } from '../../../../utils/common';
import { StatusNewBadge } from '../../../common/StatusBadge';
import {
  ENROLLMENT_REFUND_STATUS,
  ENROLLMENT_TYPE,
  PAYMENT_ACCOUNT_TYPE,
  REFUND_ELIGIBLE_TYPE,
  TRANSACTION_METHODS,
} from '../../../../constants/status';
import { Download, FileSpreadsheet, Printer } from 'lucide-react';
import NewDropdown from '../../../common/NewDropDown';
import { exportTransactionsReport } from '../Transaction/service/transactionService';
import Dropdown from '../../../common/DropDown';
import { getGroupList } from '../Group/services/groupServices';
import { getAuctionList } from '../Auction/services/auctionService';
import { imageUrl } from '../../../../constants/global';
import { AuctionsListModal } from './components/AuctionsListModal';
import { DetailsModal } from './components/DetailsModal';
import { getRefunds, bulkRefundAction } from './services/refundService';
import { NavLink } from 'react-router-dom';

const user = getLoggedUser();

const roleAllowedStatuses = {
  A: ['pending_mzadcom', 'pending_client', 'approved', 'rejected'],
  C: ['pending_mzadcom', 'pending_client', 'approved', 'rejected'],
  CE: ['pending_mzadcom', 'pending_client', 'approved', 'rejected'],
  GM: ['pending_mzadcom', 'pending_client', 'approved', 'rejected'],
  PM: ['pending_mzadcom', 'pending_client', 'approved', 'rejected'],
  OM: ['pending_mzadcom', 'pending_client', 'approved', 'rejected'],
  F: ['pending_mzadcom', 'pending_client', 'approved', 'rejected'],
};
const allStatuses = [
  {
    type: 'pending_mzadcom',
    title: i18n.t('awaiting_mzadcom_approval'),
    amount: 0,
    auctionCount: 0,
    countLabel: i18n.t('requests'),
  },
  {
    type: 'pending_client',
    title: i18n.t('awaiting_client_approval'),
    amount: 0,
    auctionCount: 0,
    countLabel: i18n.t('requests'),
  },
  {
    type: 'approved',
    title: i18n.t('completed'),
    amount: 0,
    auctionCount: 0,
    countLabel: i18n.t('requests'),
  },
  {
    type: 'rejected',
    title: i18n.t('rejected'),
    amount: 0,
    auctionCount: 0,
    countLabel: i18n.t('requests'),
  },
];
const allowedStatuses = user ? roleAllowedStatuses[user.role] || [] : [];
const filteredMeta = allStatuses.filter((card) => allowedStatuses.includes(card.type));

export class RefundListNew extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        startDate: null,
        endDate: null,
        method: '',
        client: null,
        group: null,
        auction: null,
        bidder: '',
      },
      status: filteredMeta[0]?.type || 'pending_mzadcom', // default to first allowed
      activeTab: filteredMeta[0]?.type || 'pending_mzadcom',
      cardMeta: filteredMeta,
      clients: [],
      groups: [],
      auctions: [],
      bidders: [],
      enrollments: [],
      isLoading: false,
      groupLoading: false,
      limit: 15,
      page: 1,
      total: 0,
      showAction: false,
      selectedRow: null,
      confirmAction: null,
      showAuctionsModal: false,
      selectedAuctions: [],
      // ── Bulk select/approve/reject (PM, pending_mzadcom only) ──
      selectedIds: [],
      showConfirm: false,
      rejectNote: null,
      rejectNoteError: null,
      actionLoading: false,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      startDate: params.get('startDate') || null,
      endDate: params.get('endDate') || null,
      category: params.get('method') || null,
      client: params.get('client') ? parseInt(params.get('client')) : null,
      group: params.get('group') ? parseInt(params.get('group')) : null,
      auction: params.get('auction') ? parseInt(params.get('auction')) : null,
      bidder: params.get('bidder') || '',
    };
    const defaultStatus = user?.role === 'C' ? 'pending_client' : 'pending_mzadcom';

    const status = params.get('status') || defaultStatus;
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, status, page, limit, activeTab: status }, () => {
      //   this.();
      this.fetchRefunds();
      this.fetchClientList();
      this.fetchGroupList();
      this.fetchAuctionList();
      this.fetchBidderList();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }

  async fetchRefunds() {
    // Reset any bulk selection whenever the underlying data set changes
    this.setState({ isloading: true, selectedIds: [] });

    const { limit, page, activeTab } = this.state;
    const { startDate, endDate, method, client, group, auction, bidder } = this.state.search;

    const q = {
      page,
      limit,
    };

    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;
    if (method) q.method = method;
    if (client) q.client = client;
    if (group) q.group = group;
    if (auction) q.auction = auction;
    if (bidder) q.bidder = bidder;

    // URL should contain the tab name
    this.updateUrlQuery({
      ...q,
      status: activeTab,
    });

    const statusMap = {
      pending_mzadcom: 'A',
      pending_client: 'WC',
      approved: 'PA',
      rejected: 'rejected',
    };
    q.status = statusMap[activeTab];
    try {
      const response = await getRefunds(q);

      if (response.success) {
        const summary = response.meta.summary || {};

        const cardMeta = filteredMeta.map((card) => ({
          ...card,
          amount: summary[card.type]?.amount ?? 0,
          auctionCount: summary[card.type]?.count ?? 0,
        }));

        this.setState({
          enrollments: response.data,
          total: response.meta.total,
          summary,
          cardMeta,
        });
      }
    } catch (error) {
      console.error('Transaction fetch failed:', error);
    } finally {
      this.setState({ isloading: false });
    }
  }

  async fetchClientList() {
    this.setState({ clientLoading: true });

    try {
      const { startDate, endDate } = this.state.search;

      const q = {};
      if (startDate) q.startDate = startDate;
      if (endDate) q.endDate = endDate;

      const response = await getClients(q);

      if (response.success) {
        this.setState({
          clients: [
            {
              value: null,
              label: i18n.t('all') || 'All',
            },
            ...response.data.map((item) => ({
              value: item.id,
              label: item.organization_name,
            })),
          ],
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ clientLoading: false });
    }
  }

  async fetchGroupList() {
    this.setState({ groupLoading: true });

    try {
      const { startDate, endDate, client } = this.state.search;

      const q = {};
      if (startDate) q.startDate = startDate;
      if (endDate) q.endDate = endDate;
      if (client) q.organization = client;

      const response = await getGroupList(q);

      if (response.success) {
        this.setState({
          groups: [
            {
              value: null,
              label: i18n.t('all') || 'All',
              organization: null,
            },
            ...(response.data ?? []).map((item) => ({
              value: item.id,
              label: item.group_name,
              organization: item.organization,
            })),
          ],
        });
      }
    } catch (error) {
      console.error('Failed to fetch groups', error);
    } finally {
      this.setState({ groupLoading: false });
    }
  }

  async fetchAuctionList() {
    this.setState({ auctionLoading: true });
    const { group } = this.state.search;
    const q = group ? { groupId: group } : {};
    const response = await getAuctionList(q);
    if (response.success) {
      const auctions = response.data.map((item) => ({
        value: item.id,
        label: item.title,
      }));
      this.setState({ auctions, auctionLoading: false });
    } else {
      this.setState({ auctionLoading: false });
    }
  }
  async fetchBidderList() {
    this.setState({ bidderLoading: true });

    try {
      const { startDate, endDate } = this.state.search;

      const q = {};
      if (startDate) q.startDate = startDate;
      if (endDate) q.endDate = endDate;

      const response = await getBidders(q);

      if (response.success) {
        const bidders = [
          {
            value: null,
            label: i18n.t('all') || 'All',
          },
          ...response.data.map((item) => ({
            value: item.id,
            label: `${item.name} (${item.id})`,
          })),
        ];
        this.setState({
          bidders,
          bidderLoading: false,
        });
      }
    } catch (error) {
      console.error('Failed to fetch bidders', error);
    } finally {
      this.setState({ bidderLoading: false });
    }
  }

  handleClientChange = (selectedOption) => {
    const clientValue = selectedOption ? parseInt(selectedOption.value) : null;
    this.setState(
      (prevState) => ({
        search: {
          ...prevState.search,
          client: clientValue,
          group: null,
          bidder: null,
          auction: null,
        },
        groups: [],
        bidders: [],
        auctions: [],
      }),
      async () => {
        await this.fetchGroupList();
        await this.fetchAuctionList();
        await this.fetchBidderList();
      }
    );
  };

  handleGroupChange = (selectedOption) => {
    const groupValue = selectedOption ? parseInt(selectedOption.value) : null;
    const clientValue = selectedOption?.organization || null;

    this.setState(
      (prevState) => ({
        search: {
          ...prevState.search,
          client: clientValue,
          group: groupValue,
          bidder: null,
          auction: null,
        },
      }),
      async () => {
        await this.fetchAuctionList();
        await this.fetchBidderList();
      }
    );
  };

  handleAuctionChange = (selectedOption) => {
    this.setState((prevState) => ({
      search: {
        ...prevState.search,
        auction: selectedOption ? parseInt(selectedOption.value) : null,
      },
    }));
  };
  //  Bidder onChange — store as integer
  handleBidderChange = (selectedOption) => {
    this.setState((prevState) => ({
      search: {
        ...prevState.search,
        bidder: selectedOption ? parseInt(selectedOption.value) : null,
      },
    }));
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = {
          ...prevState.search,
          [name]: value,
          // Clear group when client changes or is cleared
          ...(name === 'client' && { group: null }),
        };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client' && value) {
          // Only load if client has value
          this.fetchGroupList();
        }
      }
    );
  };

  handleSearch = () => {
    // this.();
    this.fetchRefunds();
  };

  handleClear = () => {
    const defaultSearch = {
      startDate: null,
      endDate: null,
      method: '',
      client: null,
      group: null,
      auction: null,
      bidder: null,
    };

    this.setState(
      {
        search: defaultSearch,
        page: 1,
      },
      () => {
        // this.();
        this.fetchRefunds();
      }
    );
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.fetchRefunds();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.fetchRefunds();
    });
  };

  handleCardSelect = (cardType) => {
    this.setState(
      {
        activeTab: cardType,
        status: cardType,
        page: 1,
        selectedIds: [],
      },
      () => {
        // this.();
        this.fetchRefunds();
      }
    );
  };

  handleActions = (row) => {
    this.setState({
      showAction: true,
      selectedRow: row,
    });
  };

  handleViewAuctions = (row) => {
    this.setState({
      showAuctionsModal: true,
      selectedAuctions: row.auctions || [],
    });
  };
  handleRowClick = (row) => {
    this.setState({
      showAction: true,
      selectedRow: row,
    });
  };

  // ── Bulk select/approve/reject (PM role, pending_mzadcom tab only) ──

  // "Select all" only picks up rows that are eligible for refund;
  // ineligible rows must be selected manually, one at a time.
  isRowEligibleForBulkSelect = (row) => row.refund_status === 'A' && row.is_refund_eligible;

  handleCheckboxChange = (row) => {
    this.setState((prev) => {
      const selectedIds = prev.selectedIds.includes(row.id)
        ? prev.selectedIds.filter((id) => id !== row.id)
        : [...prev.selectedIds, row.id];
      return { selectedIds };
    });
  };

  handleCheckAll = (rows) => {
    const eligibleIds = rows.filter((r) => this.isRowEligibleForBulkSelect(r)).map((r) => r.id);

    this.setState((prev) => {
      const allSelected =
        eligibleIds.length > 0 && eligibleIds.every((id) => prev.selectedIds.includes(id));
      return { selectedIds: allSelected ? [] : eligibleIds };
    });
  };

  handleBulkApprove = () => {
    this.setState({ showConfirm: true, confirmAction: 'approve' });
  };

  handleBulkReject = () => {
    this.setState({ showConfirm: true, confirmAction: 'reject' });
  };

  handleBulkConfirm = async () => {
    const { confirmAction, selectedIds, rejectNote } = this.state;

    if (confirmAction === 'reject' && (!rejectNote || rejectNote.trim() === '')) {
      this.setState({
        rejectNoteError: i18n.t('reject_note_required') || 'Reject note is required.',
      });
      return;
    }

    const payload = {
      ids: selectedIds,
      action: confirmAction, // 'approve' | 'reject'
      reason: rejectNote,
    };

    this.setState({ actionLoading: true });

    try {
      const response = await bulkRefundAction(payload);

      if (response.success) {
        swal({
          title: i18n.t('success') || 'Success',
          text:
            confirmAction === 'approve'
              ? i18n.t('refund_bulk_approved') || 'Selected refunds approved successfully.'
              : i18n.t('refund_bulk_rejected') || 'Selected refunds rejected successfully.',
          icon: 'success',
          buttons: false,
          timer: 2000,
        });

        this.setState(
          {
            actionLoading: false,
            showConfirm: false,
            confirmAction: null,
            selectedIds: [],
            rejectNote: null,
            rejectNoteError: null,
          },
          () => this.fetchRefunds()
        );
      } else {
        swal({
          title: i18n.t('failed') || 'Failed',
          text: response.message || 'Failed to process the selected refunds.',
          icon: 'error',
          buttons: false,
          timer: 2000,
        });
        this.setState({ actionLoading: false });
      }
    } catch (error) {
      swal({
        title: i18n.t('error') || 'Error',
        text: 'Something went wrong.',
        icon: 'error',
        buttons: false,
        timer: 2000,
      });
      this.setState({ actionLoading: false });
    }
  };

  handleBulkCancel = () => {
    this.setState({
      showConfirm: false,
      confirmAction: null,
      rejectNote: null,
      rejectNoteError: null,
    });
  };

  getColumns = () => {
    // const isFinance = user?.role === 'F';
    const isProjecManger = user?.role === 'PM';
    const isClient = user?.role === 'C';
    const { enrollments, selectedIds } = this.state;

    // Bulk checkbox column is only relevant for PM on the pending_mzadcom tab
    const showBulkSelect = isProjecManger && this.state.activeTab === 'pending_mzadcom';

    const columns = [
      {
        name: i18n.t('sl_no'),
        width: '100px',
        sortable: true,
        wrap: true,
        cell: (row, i) => i + 1,
      },
      {
        name: i18n.t('action'),
        minWidth: '90px',
        center: true,
        cell: (row) => {
          const canShow =
            (isProjecManger && row.refund_status === 'A') ||
            (isClient && row.refund_status === 'WC');

          return canShow ? (
            <div className="action-buttons">
              <button
                className="button1 button1-primary button1-action"
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleActions(row);
                }}
                disabled={Number(row.debit) <= 0}
              >
                {i18n.t('action')}
              </button>
            </div>
          ) : (
            <span className="attachment-empty">No Action</span>
          );
        },
      },
      {
        name: i18n.t('id'),
        width: '90px',
        wrap: true,
        cell: (row) => <span>{row.id}</span>,
      },
      {
        name: i18n.t('bidder'),
        minWidth: '220px',
        wrap: true,
        cell: (row) => (
          <div className="table-identity">
            <div
              className="table-identity__avatar"
              style={{ backgroundColor: getAvatarColor(row?.user_id) }}
            >
              {getInitials(row?.user?.name)}
            </div>
            <div className="table-identity__meta">
              <span className="table-identity__name" title={row?.user?.name}>
                {row?.user?.name || '--'}
              </span>
              <span className="table-identity__sub">ID: {row?.user_id}</span>
            </div>
          </div>
        ),
      },
      {
        name: i18n.t('client'),
        width: '120px',
        cell: (row) => (
          <span>
            {row?.group?.organization_details?.organization_name || '--'} (
            {row?.group?.organization_details?.id})
          </span>
        ),
      },
      {
        name: i18n.t('group'),
        width: '120px',
        cell: (row) => (
          <span>
            {row?.group?.group_name || '--'} ({row?.group?.id})
          </span>
        ),
      },
      {
        name: i18n.t('level'),
        width: '110px',
        cell: (row) => <StatusNewBadge status={ENROLLMENT_TYPE[row?.group?.is_grouped_enroll]} />,
      },

      {
        name: i18n.t('auction'),
        width: '160px',
        wrap: true,
        cell: (row) =>
          row?.group?.is_grouped_enroll ? (
            <button
              type="button"
              className="button-table"
              onClick={(e) => {
                e.stopPropagation();
                this.handleViewAuctions(row);
              }}
            >
              {i18n.t('list_auction')} ({row.auctions?.length || 0})
            </button>
          ) : (
            <>
              {/* <span className="highlight-table-value-secondary">{row.auction?.title}</span> */}
              <button
                type="button"
                className="button-table"
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleViewAuctions(row);
                }}
              >
                {row.auction?.title}
              </button>
            </>
          ),
      },
      {
        name: i18n.t('eligibility'),
        width: '110px',
        cell: (row) => <StatusNewBadge status={REFUND_ELIGIBLE_TYPE[row.is_refund_eligible]} />,
      },
      {
        name: i18n.t('type'),
        width: '110px',
        cell: (row) => <StatusNewBadge status={TRANSACTION_METHODS[row.pay_type]} />,
      },
      {
        name: i18n.t('amount'),
        width: '110px',
        cell: (row) => <span>{row?.amount || '--'}</span>,
      },
      {
        name: i18n.t('user_hold'),
        width: '110px',
        cell: (row) => <span>{row?.user?.hold_amount || '--'}</span>,
      },
      {
        name: i18n.t('payment_date'),
        width: '170px',
        cell: (row) => (
          <span className="highlight-table-value-secondary">
            {row.transfer_date ? formatDate(row.transfer_date) : '--'}
          </span>
        ),
      },
      {
        name: i18n.t('receipt'),
        width: '130px',
        wrap: true,
        cell: (row) => {
          const receiptPath = row.file_receipt
            ? `uploads/enrolls/receipt/${row.file_receipt}`
            : null;

          return receiptPath ? (
            <a
              className="button-table"
              href={`${imageUrl}${receiptPath}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              <FileSpreadsheet size={18} /> {i18n.t('receipt')}
            </a>
          ) : (
            <span className="attachment-empty">{i18n.t('no_receipt')}</span>
          );
        },
      },
      {
        width: '170px',
        name: i18n.t('account'),
        cell: (row) => (
          <StatusNewBadge status={PAYMENT_ACCOUNT_TYPE[row.payment_account_type_id]} />
        ),
        wrap: true,
      },
      {
        name: i18n.t('client_approval_doc'),
        width: '150px',
        wrap: true,
        cell: (row) => {
          const receiptPath = row.client_approval_doc
            ? `uploads/enrolls/receipt/${row.client_approval_doc}`
            : null;

          return receiptPath ? (
            <a
              className="button-table"
              href={`${imageUrl}${receiptPath}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              <FileSpreadsheet size={18} /> {i18n.t('approval_doc')}
            </a>
          ) : (
            <span className="attachment-empty">{i18n.t('no_approval_doc')}</span>
          );
        },
      },
      {
        width: '220px',
        name: i18n.t('refund_status'),
        cell: (row) => <StatusNewBadge status={ENROLLMENT_REFUND_STATUS[row.refund_status]} />,
        wrap: true,
      },
    ];

    columns.push({
      name: i18n.t('enrolled_date'),
      width: '170px',
      cell: (row) => (
        <span className="highlight-table-value-secondary">{formatDate(row.created_at)}</span>
      ),
    });

    if (showBulkSelect) {
      const eligibleIds = enrollments
        .filter((r) => this.isRowEligibleForBulkSelect(r))
        .map((r) => r.id);
      const allEligibleSelected =
        eligibleIds.length > 0 && eligibleIds.every((id) => selectedIds.includes(id));

      columns.unshift({
        name: (
          <input
            type="checkbox"
            checked={allEligibleSelected}
            disabled={eligibleIds.length === 0}
            onChange={() => this.handleCheckAll(enrollments)}
          />
        ),
        width: '50px',
        center: true,
        cell: (row) => {
          // Only refunds still awaiting Mzadcom (PM) approval can be bulk selected
          if (row.refund_status !== 'A') {
            return null;
          }
          return (
            <input
              type="checkbox"
              checked={selectedIds.includes(row.id)}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                e.stopPropagation();
                this.handleCheckboxChange(row);
              }}
            />
          );
        },
      });
    }

    return columns;
  };

  handleDownload = async (fileType) => {
    const { activeTab } = this.state;
    const { startDate, endDate, bidder } = this.state.search;

    let exportApi = exportTransactionsReport;
    let fileName = 'Withdrawal_Report';

    const apiQuery = {
      method: 'offline',
      type: 'withdraw',
      fileType,
    };
    if (bidder) apiQuery.bidder = bidder;
    if (startDate) apiQuery.startDate = startDate;
    if (endDate) apiQuery.endDate = endDate;

    const statusMap = {
      A: {
        pending: 'W',
        admin_approved: 'WA',
        completed: 'R',
        admin_rejected: 'RA',
        finance_rejected: 'RF',
      },
      F: {
        pending: 'W',
        admin_approved: 'WA',
        completed: 'R',
        finance_rejected: 'RF',
      },
      CE: {
        pending: 'W',
        admin_approved: 'WA',
        completed: 'R',
      },
      GM: {
        pending: 'W',
        admin_approved: 'WA',
        completed: 'R',
      },
    };

    apiQuery.status = statusMap[user?.role]?.[activeTab];

    this.setState({ exportLoading: true });

    try {
      await exportApi({
        params: apiQuery,
        fileType,
        fileName,
      });
    } finally {
      this.setState({ exportLoading: false });
    }
  };
  renderListContent() {
    const {
      clients,
      clientLoading,
      groups,
      groupLoading,
      auctions,
      auctionLoading,
      bidders,
      bidderLoading,
      enrollments,
      isloading,
      selectedIds,
      activeTab,
    } = this.state;

    const { startDate, endDate } = this.state.search;
    const isProjecManger = user?.role === 'PM';

    return (
      <>
        <div className="client-cards-container-new">
          {this.state.cardMeta.map((config) => (
            <ClientAmountCard
              key={config.type}
              {...config}
              selected={this.state.activeTab === config.type}
              onSelect={this.handleCardSelect}
            />
          ))}
        </div>
        <FilterSection
          loading={this.state.isLoading}
          onSearch={this.handleSearch}
          onClear={this.handleClear}
        >
          {/* Start Date */}
          <div className="select-wrapper floating-label-wrapper">
            <input
              id="startDate"
              type="date"
              name="startDate"
              value={startDate || ''}
              onChange={this.handleSearchChange}
              className="filter-base floating-input"
              placeholder=" "
            />
            <label htmlFor="startDate" className="floating-label">
              {i18n.t('start_date')}
            </label>
          </div>

          {/* End Date */}
          <div className="select-wrapper floating-label-wrapper">
            <input
              id="endDate"
              type="date"
              name="endDate"
              value={endDate || ''}
              onChange={this.handleSearchChange}
              className="filter-base floating-input"
              placeholder={i18n.t('end_date')}
            />
            <label htmlFor="endDate" className="floating-label">
              {i18n.t('end_date')}
            </label>
          </div>

          {/* Payment Type Dropdown */}
          <Dropdown
            name="method"
            value={this.state.search.method}
            onChange={this.handleSearchChange}
            placeholder={i18n.t('payment_method')}
            empty={i18n.t('select_method')}
            options={[
              { value: 'online', label: i18n.t('online') },
              { value: 'offline', label: i18n.t('offline') },
              { value: 'wallet', label: i18n.t('wallet') },
            ]}
          />

          {/* Client Dropdown */}
          <div className="react-select-wrapper">
            <Select
              options={clients}
              value={clients.find((c) => c.value === this.state.search.client) || null}
              onChange={this.handleClientChange}
              name="client"
              styles={selectStyles}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              placeholder={clientLoading ? `${i18n.t('loading')}...` : i18n.t('all')}
              isLoading={clientLoading}
              isDisabled={clientLoading}
              isClearable
            />
            <label className="react-select-label">{i18n.t('client') || 'Client'}</label>
          </div>

          {/* Group Dropdown */}
          <div className="react-select-wrapper">
            <Select
              options={groups}
              value={groups.find((c) => c.value === this.state.search.group) || null}
              onChange={this.handleGroupChange}
              name="group"
              styles={selectStyles}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              placeholder={groupLoading ? `${i18n.t('loading')}...` : i18n.t('all')}
              isLoading={groupLoading}
              isDisabled={groupLoading}
              isClearable
            />
            <label className="react-select-label">{i18n.t('group_name')}</label>
          </div>

          {/* Auction Dropdown */}
          <div className="react-select-wrapper">
            <Select
              options={auctions}
              value={auctions.find((c) => c.value === this.state.search.auction) || null}
              onChange={this.handleAuctionChange}
              name="auction"
              styles={selectStyles}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              placeholder={auctionLoading ? `${i18n.t('loading')}...` : i18n.t('all')}
              isLoading={auctionLoading}
              isDisabled={auctionLoading}
              isClearable
            />
            <label className="react-select-label">{i18n.t('auction_name')}</label>
          </div>

          {/* Bidder Dropdown */}
          <div className="react-select-wrapper">
            <Select
              options={bidders}
              value={bidders.find((c) => c.value === this.state.search.bidder) || null}
              onChange={this.handleBidderChange}
              name="bidder"
              styles={selectStyles}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              placeholder={bidderLoading ? `${i18n.t('loading')}...` : i18n.t('all')}
              isLoading={bidderLoading}
              isDisabled={bidderLoading}
              isClearable
            />
            <label className="react-select-label">{i18n.t('bidder')}</label>
          </div>
        </FilterSection>

        {isProjecManger && activeTab === 'pending_mzadcom' && selectedIds.length > 0 && (
          <WarningBox
            data={selectedIds}
            onApprove={this.handleBulkApprove}
            onReject={this.handleBulkReject}
          />
        )}

        <div className="Data-Listing">
          {isloading ? (
            <TableSkeleton columns={10} rows={10} />
          ) : enrollments.length ? (
            <DataTable
              responsive={true}
              columns={this.getColumns()}
              data={enrollments}
              customStyles={tableStyles}
              highlightOnHover
              onRowClicked={this.handleRowClick}
              pagination
              paginationServer
              paginationTotalRows={this.state.total}
              paginationPerPage={this.state.limit}
              paginationDefaultPage={this.state.page}
              paginationRowsPerPageOptions={[15, 25, 50, 100]}
              paginationComponentOptions={{
                rowsPerPageText: i18n.t('rows_per_page'),
                rangeSeparatorText: i18n.t('out'),
              }}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          ) : (
            <NoData
              message={i18n.t('no_enrollments_available')}
              actionText={i18n.t('refresh')}
              onAction={this.fetchRefunds.bind(this)}
            />
          )}
        </div>
      </>
    );
  }

  renderExportAction() {
    const { enrollments, exportLoading } = this.state;

    return (
      <NewDropdown
        label={i18n.t('export')}
        loading={exportLoading}
        disabled={enrollments.length === 0}
        icon={Download}
        items={[
          {
            label: i18n.t('excel'),
            icon: FileSpreadsheet,
            onClick: () => this.handleDownload('excel'),
          },
          {
            label: i18n.t('pdf'),
            icon: Printer,
            onClick: () => this.handleDownload('pdf'),
          },
        ]}
      />
    );
  }
  render() {
    const isClientRole = user?.role === 'C';
    const isProjecManger = user?.role === 'PM';

    const modals = (
      <>
        <AuctionsListModal
          show={this.state.showAuctionsModal}
          auctions={this.state.selectedAuctions}
          onClose={() => this.setState({ showAuctionsModal: false, selectedAuctions: [] })}
        />
        <DetailsModal
          show={this.state.showAction}
          selectedTransaction={this.state.selectedRow}
          role={user?.role}
          onClose={() =>
            this.setState({
              showAction: false,
              selectedRow: null,
            })
          }
          onComplete={() => {
            this.fetchRefunds();
            this.setState({ showAction: false, selectedRow: null });
          }}
        />

        {isProjecManger && (
          <ConfirmModal
            show={this.state.showConfirm}
            onClose={this.handleBulkCancel}
            title={
              this.state.confirmAction === 'approve'
                ? i18n.t('approve_confirmation') || 'Approve Confirmation'
                : i18n.t('reject_confirmation') || 'Reject Confirmation'
            }
            onConfirm={this.handleBulkConfirm}
            onCancel={this.handleBulkCancel}
            confirmText={
              this.state.confirmAction === 'approve'
                ? i18n.t('approve') || 'Approve'
                : i18n.t('reject') || 'Reject'
            }
            cancelText={i18n.t('cancel') || 'Cancel'}
            loading={this.state.actionLoading}
          >
            {this.state.confirmAction === 'reject' && (
              <div className="reject-note-container">
                <p>
                  {i18n.t('reject_reason_prompt') ||
                    'Please provide the reason for rejecting the selected refund(s).'}
                </p>
                <textarea
                  id="rejectNote"
                  value={this.state.rejectNote || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    this.setState({
                      rejectNote: value,
                      rejectNoteError:
                        value.trim() === ''
                          ? i18n.t('reject_note_required') || 'Reject note is required.'
                          : null,
                    });
                  }}
                  placeholder={i18n.t('enter_reject_reason') || 'Enter reason for rejection'}
                  rows={3}
                  className={`reject-note-textarea ${this.state.rejectNoteError ? 'is-invalid' : ''}`}
                />
                {this.state.rejectNoteError && (
                  <p className="error-text">{this.state.rejectNoteError}</p>
                )}
              </div>
            )}
            {this.state.confirmAction === 'approve' && (
              <p className="modal-message">
                {i18n.t('confirm_bulk_approve') ||
                  `Are you sure you want to approve ${this.state.selectedIds.length} selected refund(s)?`}
              </p>
            )}
          </ConfirmModal>
        )}
      </>
    );

    if (isClientRole) {
      return (
        <React.Fragment>
          <div className="cd-page">
            <div className="cd-shell">
              <p className="cd-crumb">
                <NavLink to="/client-management">{i18n.t('dashboard')}</NavLink>
                <span className="cd-crumb__current">{i18n.t('enrollment_refund')}</span>
              </p>

              <header className="cd-hero cd-hero--compact">
                <h1 className="cd-hero__title">{i18n.t('refund_requests') || 'Refund Requests'}</h1>
                <p className="cd-hero__sub">
                  {i18n.t('track_refund_requests') || 'Track and manage your refund requests.'}
                </p>
              </header>

              <div className="card">
                <div className="card-header">
                  <div className="header-action">{this.renderExportAction()}</div>
                </div>
                <div className="card-body">{this.renderListContent()}</div>
              </div>
            </div>
          </div>
          {modals}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('refund_requests')}
          subtitle={i18n.t('track_refund_requests')}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    <div className="header-action">{this.renderExportAction()}</div>
                  </div>
                  <div className="card-body">{this.renderListContent()}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {modals}
      </React.Fragment>
    );
  }
}
